module.exports = __webpack_public_path__ + "img/Free-Hair-Curls-Long-Curly-Hair.abef971f.jpg";